<mat-paginator
  *ngIf="pageable"
  (page)="handlePageEvent($event)"
  [hidePageSize]="true"
  [pageSize]="pageable()?.size"
  [length]="pageable()?.totalElements"
  [pageIndex]="pageable()?.page"
  [pageSizeOptions]="[]"
  showFirstLastButtons
  [class]="class"
>
</mat-paginator>
